var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(this.$route.name === "employees")?_c('b-row',[_c('LISTEMPLOYEES')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }